import React from 'react';
import { Box, Flex, Text } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

const Summary = ({ text, prefix, ...props }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Flex alignItems="center" justifyContent="flex-end" {...props}>
    {prefix && (
      <Box mr="1" size={20}>
        {prefix}
      </Box>
    )}
    <Text textStyle="summary" fontSize={['xs', null, 'sm']}>
      {text}
    </Text>
  </Flex>
);

Summary.propTypes = {
  text: PropTypes.string.isRequired,
  prefix: PropTypes.node,
  ...Flex.propTypes,
};

export default Summary;
